export const UserLogout=() =>{
  return {
    type: 'USER_LOGOUT',
  }
}
export const logIn=(data) =>{
    return {
      type: 'Login',
      payload: data
    }
  }
export const PracticeID = (id) => {
    return {
      type: 'PracticeID',
      payload: id
    }
}
  